"use client";

import React from "react";
import { Compass, Layers, LayoutGrid, Gem } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  id: 1,
  title: "Qualidade de Produção",
  description: "Entregamos excelência técnica em cada frame e captação, utilizando equipamentos de ponta para garantir um resultado audiovisual de padrão cinematográfico.",
  icon: Compass
}, {
  id: 2,
  title: "Engajamento de Audiência",
  description: "Desenvolvemos conteúdos que prendem a atenção do início ao fim, aumentando o tempo de retenção e a interação do seu público com a sua marca.",
  icon: Layers
}, {
  id: 3,
  title: "Posicionamento de Marca",
  description: "Utilizamos o storytelling visual para elevar a percepção de valor da sua empresa, transformando autoridade técnica em desejo de consumo.",
  icon: LayoutGrid
}, {
  id: 4,
  title: "Estratégia de Conteúdo",
  description: "Planejamos cada produção com foco em distribuição multicanal, garantindo que seu investimento gere resultados em diferentes plataformas digitais.",
  icon: Gem
}];
export default function Diferencial() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: listRef,
    isVisible: isListVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="diferencial" className="bg-background py-24 lg:py-40 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-start">
          
          {}
          <div ref={headerRef} className={`lg:col-span-5 lg:sticky lg:top-32 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-4xl md:text-5xl lg:text-[3.5rem] font-bold text-foreground font-default leading-[1.1] tracking-tight">
              Qualidade que posiciona
            </h2>
            <p className="mt-6 text-xl text-muted-foreground leading-relaxed">
              Cada projeto é pensado para gerar impacto visual, clareza de mensagem e posicionamento de marca.
            </p>
            <div className="w-20 h-1 bg-primary mt-8 rounded-full"></div>
          </div>

          {}
          <div ref={listRef} className={`lg:col-span-7 lg:col-start-6 flex flex-col gap-12 md:gap-16 transition-all duration-1000 delay-200 ease-out ${isListVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return <div key={benefit.id} data-index={i} className="flex flex-col sm:flex-row gap-6 md:gap-8 items-start group">
                  <div className="flex-shrink-0 p-4 rounded-2xl bg-secondary/50 border border-border/50 group-hover:border-primary/30 group-hover:bg-secondary transition-colors duration-300">
                    <Icon className="w-10 h-10 md:w-12 md:h-12 text-primary" strokeWidth={2} />
                  </div>
                  <div className="flex flex-col gap-3 pt-2">
                    <h3 className="text-2xl md:text-3xl font-semibold text-foreground font-default tracking-tight">
                      {benefit.title}
                    </h3>
                    <p className="text-lg text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>

        </div>
      </div>
    </section>;
}